import React from "react";
import { Heading, Box, Flex, Text, Button } from "@chakra-ui/react";

function NoDataScreen() {
    return (
        <Flex 
            minH={'100vh'}
            justify={'center'}
            bg={'#F4F4F4'}
        >
            <Flex align={'center'} justify={'center'}>
                <Box textAlign="center" py={10} px={6}>
                <Heading
                    display="inline-block"
                    as="h2"
                    size="4xl"
                    bgGradient="linear(to-r, blue.400, blue.500, blue.600)"
                    backgroundClip="text">
                    404
                </Heading>
                    <Heading as="h2" size="xl" mt={6} mb={2}>
                        No Sales Data Found.
                    </Heading>
                    <Text color={'gray.500'}>
                        This product has no sales data yet.
                    </Text>
                    <Text color={'gray.500'}>
                        Orders have yet to be placed for this product.
                    </Text>
                    <Box pt={8}>
                        <a href="/">
                            <Button
                                colorScheme="blue"
                                bgGradient="linear(to-r, blue.400, blue.500, blue.600)"
                                color="white"
                                variant="solid"
                            >
                                Return to Home
                            </Button>
                        </a>
                    </Box>
                </Box>
            </Flex>
        </Flex>
    )
}

export default NoDataScreen;